<template>
  <v-card style="position: relative;">
    <v-card-text style="min-height: 396px;">
      <!-- <div>
        <div class="subheading font-weight-medium baseline">
          Report format
          <v-menu offset-y open-on-hover :open-delay="400">
            <template v-slot:activator="{ on }">
              <v-icon v-on="on" class="clickable ml-2" color="primary">
                info_outline
              </v-icon>
            </template>
            <v-card>
              <v-card-text>
                <div class="mb-2">
                  <strong>Standard</strong> reports show analytes as rows &mdash;
                  this format is similar to most EnviroData reports.
                </div>
                <div class="mb-2">
                  <strong>Wide</strong> reports show analytes as columns.
                </div>
                <div>
                  <strong>Long</strong> reports are easily parsed by programming languages such as R.
                </div>
              </v-card-text>
            </v-card>
          </v-menu>
        </div>
        <v-radio-group :disabled="disabled" class="mt-1 mb-4" hide-details v-model="reportOptions.reportFormat">
          <v-layout>
            <v-flex v-for="(reportType, index) in reportTypes" :key="`reportType-${index}`">
              <v-radio color="primary" :value="reportType.value">
                <template v-slot:label>
                  <div>
                    <div class="font-weight-">{{ reportType.name }}</div>
                    <div class="caption">{{ reportType.format }}</div>
                  </div>
                </template>
              </v-radio>
            </v-flex>
          </v-layout>
        </v-radio-group>
      </div> -->

      <div>
        <div class="subheading font-weight-medium baseline">
          Include Gaps Data
          <v-menu offset-y open-on-hover :open-delay="400">
            <template v-slot:activator="{ on }">
              <v-icon v-on="on" class="clickable ml-2" color="primary">
                info_outline
              </v-icon>
            </template>
            <v-card>
              <v-card-text>
                <div class="mb-2">
                  <strong>Yes</strong> Gaps data would be included in the report.
                </div>
                <div class="mb-2">
                  <strong>No</strong> Gaps data would be excluded from the report.
                </div>                
              </v-card-text>
            </v-card>
          </v-menu>
        </div>
        <v-radio-group :disabled="disabled" class="mt-1 mb-4" hide-details v-model="reportOptions.includeGaps">
          <v-layout>
            <v-flex>
              <v-radio color="primary" label="Yes" :value="true">
              </v-radio>
            </v-flex>
            <v-flex>
              <v-radio color="primary" label="No" :value="false"></v-radio>
            </v-flex>
          </v-layout>
        </v-radio-group>
      </div>      
    </v-card-text>
  </v-card>
</template>

<script>
  import {
    reportTypes,
    reportGroupings,
    reportTypesMapping,
    defaultReportType,
    defaultReportGrouping,
  } from '@/helpers/multiStationQuery'

  export default {
    props: {
      selection: Object,
      disabled: Boolean,
    },
    data() {
      return {
        reportTypes,
        reportTypesMapping,
        reportGroupings,
        initialReportOptions: {
          includeQaQc: false,
          reportFormat: defaultReportType,
          organizeWorksheetBy: defaultReportGrouping,
          includeSummaryTab: false,
          includeEnvirodataAnalyteName: false,
          includeGaps: false,
        },
        reportOptions: {

        },
      }
    },
    watch: {
      reportOptions: {
        immediate: true,
        handler(value) {
          this.$emit('update:reportOptions', value)
        },
      },
      'reportOptions.reportFormat'(value) {
        let reportType = reportTypesMapping[value]

        let hasValue = (
          reportType.reportGroupings.some(reportGrouping =>
            reportGrouping.value.every(rg => (
                Array.isArray(this.reportOptions.organizeWorksheetBy) &&
                this.reportOptions.organizeWorksheetBy.includes(rg)) &&
              reportGrouping.value.length === this.reportOptions.organizeWorksheetBy.length
            ))
        )

        if (!hasValue) {
          if (reportType.reportGroupings.length > 0) {
            this.reportOptions.organizeWorksheetBy = reportType.reportGroupings[0].value
          } else {
            this.reportOptions.organizeWorksheetBy = null
          }
        }
      },
    },
    methods: {
      loadReportOptions(reportOptions) {
        if (reportOptions) this.reportOptions = reportOptions
        else this.reset()
      },
      reset() {
        this.reportOptions = JSON.parse(JSON.stringify(this.initialReportOptions))
      },
    },
    created() {
      this.reset()
    },
  }
</script>

<style scoped>
  .baseline {
    align-items: baseline;
    display: flex;
  }
</style>